// extracted by mini-css-extract-plugin
export default {"ImageContainer":"LogoSection_ImageContainer__82xfq"};